import type { CustomTypedTFunction } from "#modules/localization/translations"

import { z } from "zod"

export function loginDto(t: CustomTypedTFunction<"forms", "forms" | "page/login">) {
  // @compiler useTranslation("forms", "page/login")

  return z.object({
    email: z.string({ required_error: t("formErrors.emailNotValid") }).email(t("formErrors.emailNotValid")),
    password: z.string({ required_error: t("page/login:validation.passwordRequired") }).min(1, t("page/login:validation.passwordRequired")),
  })
}
